/**
 * Prompt module for interacting with virtual computers using AI models
 */

import type { PromptMessage, PromptCallback } from './types';

export interface PromptProvider {
  execute(options: PromptExecuteOptions): Promise<PromptMessage[]>;
}

export interface PromptExecuteOptions {
  computerId: string;
  instruction: string;
  callback?: PromptCallback;
  apiKey?: string;
  model?: string;
  displayWidth?: number;
  displayHeight?: number;
  orgoApiKey?: string;
  orgoBaseUrl?: string;
  maxSavedScreenshots?: number;
  thinkingEnabled?: boolean;
  thinkingBudget?: number;
  maxTokens?: number;
  maxIterations?: number;
}

// Import providers
import { AnthropicProvider } from './providers/anthropic';

// Default provider mapping
const PROVIDER_MAPPING: Record<string, new () => PromptProvider> = {
  anthropic: AnthropicProvider,
  // Add more providers here as needed
};

export function getProvider(providerName: string = 'anthropic'): PromptProvider {
  const ProviderClass = PROVIDER_MAPPING[providerName];
  
  if (!ProviderClass) {
    const available = Object.keys(PROVIDER_MAPPING).join(', ');
    throw new Error(`Unknown provider: ${providerName}. Available providers: ${available}`);
  }

  return new ProviderClass();
}